export default {
    auth: {
        attendance_success: "📅 签到完成! (Daily Rewards)\n今日获得奖励 +50积分!",
        signup_bonus: "注册成功! 🎉\n获得欢迎奖励 +100积分!",
        referral_bonus: "邀请注册完成! 🤝\n欢迎奖励 100P + 邀请奖励 500P\n总共获得 600积分!",
        login_required: "需要登录"
    },
    social: {
        subscribe_on: "已添加到订阅列表。",
        subscribe_off: "已取消订阅。",
        like_on: "已点赞!",
        like_off: "已取消点赞。",
        follow_on: "已关注。",
        follow_off: "已取消关注。"
    },
    comment: {
        submit_success: "评论已发布。",
        delete_confirm: "确定要删除吗?",
        delete_success: "已删除。",
        delete_error: "删除错误",
        submit_error: "发布评论错误",
        empty_error: "请输入内容。"
    },
    payment: {
        verify_success: "验证完成!\n已充值 {amount}星币。",
        verify_fail: "验证错误",
        user_cancel: "支付已取消。",
        error: "支付错误"
    },
    common: {
        confirm: "确认",
        cancel: "取消",
        close: "关闭",
        save: "保存",
        delete: "删除",
        edit: "编辑",
        copy: "复制",
        loading: "加载中...",
        error: "发生错误。",
        success: "成功。",
        webtoon: "网络漫画",
        webnovel: "网络小说",
        cinenovel: "Cine-Novel",
        published: "已发布",
        draft: "草稿",
        editor: "编辑器"
    },
    seo: {
        default_title: "Mirinae Platform - Where Imagination Becomes Reality",
        default_desc: "Next-gen Webtoon/Webnovel platform combining AI and Art. Become an author and create your own universe."
    },
    footer: {
        terms: "使用条款",
        privacy: "隐私政策",
        report: "举报中心",
        biz_ceo: "代表",
        biz_addr: "地址",
        biz_tel: "支持",
        biz_email: "Email",
        biz_license: "执照",
        biz_mail_order: "电商",
        biz_none: "无信息",
        system_ready: "SYSTEM READY",
        copyright: "SSULWHA WORLD"
    },
    menu: {
        home: "首页",
        webtoon: "网络漫画",
        webnovel: "网络小说",
        novel: "网络小说",
        davinci: "达芬奇",
        studio: "创作者工作室",
        library: "图书馆",
        support: "支持",
        admin: "管理",
        config: "外部链接",
        factory: "弹窗 & 通知",
        docs: "文档编辑器",
        analytics: "趋势分析",
        plaza: "Ssulwha俱乐部",
        wisdom: "星之智慧",
        recommendation: "空书架",
        charge: "星星驿站",
        guide: "指南",
        "whats-new": "新功能",
        invite: "邀请朋友",
        about: "关于服务",
        terms: "使用条款",
        privacy: "隐私政策",
        report: "举报中心",
        "app-setting": "应用设置",
        login: "登录 / 注册",
        logout: "退出登录",
        MyPage: "我的主页",
        notice: "通知",
        proposal: "提案",
        settings: "设置",
        language: "语言"
    },
    modal: {
        translate_title: "语言选择",
        translate_placeholder: "请选择要翻译的语言。",
        translate_start: "翻译"
    },
    msg: {
        welcome_beta: "欢迎使用 Mirinae Beta版。",
        login_required: "登录以解锁更多故事。",
        login_btn: "登录 / 注册"
    },
    profile: {
        follow: "关注",
        following: "已关注",
        mypage: "我的主页",
        followers: "粉丝",
        following_count: "关注",
        bio_empty: "暂无介绍。",
        works: "作品",
        feed: "动态",
        guestbook: "留言板",
        works_empty: "暂无作品。",
        works_error: "作品加载失败",
        feed_empty: "暂无动态。",
        feed_error: "无法加载动态。",
        feed_error_detail: "正在创建索引或网络错误。",
        follow_error: "关注失败。"
    },
    support: {
        title: "1:1 咨询中心",
        input_placeholder: "请输入您的咨询内容...",
        empty_state_title: "暂无咨询记录。",
        empty_state_desc: "如有疑问，请随时咨询！",
        status_received: " • 已受理",
        auto_reply: "您的意见已受理。我们将按顺序回复。在此期间，请尽情探索Ssulwha World。",
        send_fail: "消息发送失败"
    },
    author: {
        apply_title: "作家申请",
        apply_desc: "向世界讲述您的故事。请留下简单的介绍和作品集，审核后我们会与您联系。",
        email_label: "电子邮件",
        email_placeholder: "请输入可联系的电子邮件",
        email_hint: "我们可能会联系您告知审批结果及合同相关事宜。",
        intro_label: "自我介绍",
        intro_placeholder: "请介绍一下您自己。（写作经历、作品风格等）",
        portfolio_label: "作品集（可选）",
        submit_btn: "申请",
        email_required: "请输入电子邮件。",
        intro_required: "请输入自我介绍。",
        submitting: "正在申请...",
        submit_success: "作家申请已完成。"
    },
    point: {
        reason: {
            attendance: "Daily Attendance",
            reading: "Reading Reward",
            reading_reward: "Reading Reward",
            welcome: "Welcome Reward",
            referral: "Referral Reward",
            author_apply: "Author Application",
            rental: "Rental",
            purchase: "Purchase"
        }
    },
    wallet: {
        tab_title: "Wallet",
        sub_card: {
            upgrade_btn: "Upgrade Membership (₩{price}/mo)",
            coming_soon: "Coming Soon",
            tier_label: "Membership Tier",
            tier_premium: "Premium Pass",
            tier_standard: "Standard Member",
            renews_on: "Renews on"
        },
        assets: {
            activity_label: "Activity Points",
            activity_desc: "Free Earned Points",
            star_label: "Star Points",
            star_desc: "Paid Charged Points"
        },
        charge: {
            title: "Star Station",
            desc: "Charge needed stars"
        },
        history: {
            title: "Point History",
            empty: "No history found."
        }
    },
    history: {
        empty: {
            title: "暂无阅读记录",
            desc: "去浏览作品吧？",
            action_btn: "去浏览作品"
        },
        common: {
            no_title: "无标题"
        },
        last_viewed: "上次观看:",
        episode_fmt: "第{n}话",
        delete_confirm: {
            msg: "确定要删除这条记录吗？",
            title: "删除记录"
        }
    },
    library: {
        empty_title: "书架是空的",
        empty_desc: "已购买或浏览的作品将显示在这里。",
        explore_btn: "浏览作品",
        select_hint: "选择作品以查看列表。",
        total_episodes: "共 {n} 集"
    },
    badge: {
        best_reviewer: "最佳评论员",
        top_author: "顶级作家",
        vip: "VIP",
        donation_king: "赞助之王",
        hall_of_fame: "名人堂"
    },
    tab: {
        works: "作品",
        feed: "Ssulwha (Feed)",
        guestbook: "留言板"
    },
    tag: {
        fantasy: "奇幻",
        romance: "浪漫",
        martial_arts: "武侠",
        drama: "剧情",
        slice_of_life: "日常",
        comedy: "喜剧",
        thriller: "惊悚",
        school: "校园",
        munchkin: "龙傲天",
        regression: "重生",
        possession: "附身",
        system: "系统",
        growth: "成长",
        revenge: "复仇",
        heart: "治愈",
        horror: "恐怖",
        sport: "体育",
        history: "架空历史"
    },
    guestbook: {
        title: "留言板",
        input_placeholder: "留下您的支持！",
        secret: "悄悄话",
        submit: "提交",
        empty: "成为第一个留言的人吧！ 👣",
        secret_content: "这是一条悄悄话。",
        delete_confirm: "确定删除吗？",
        reply: "回复",
        reply_placeholder: "写回复...",
        reply_delete_confirm: "删除回复？",
        confirm_delete_reply: "确定删除此回复？",
        submit_error: "提交失败：",
        emoji_error: "表情加载失败"
    },
    pwa: {
        install_title: "Cài đặt",
        install_desc: "Trải nghiệm nhanh và mượt hơn.",
        install_btn: "Cài đặt",
        later_btn: "Để sau",
        ios_guide_title: "Cài đặt trên iPhone",
        ios_guide_desc: "Tận hưởng trải nghiệm toàn màn hình.",
        ios_step1: "Nhấn nút 'Chia sẻ'",
        ios_step2: "Chọn 'Thêm vào MH chính'",
        update_title: "Phiên bản mới ({version})!",
        update_title_v2: "新版本已更新！",
        update_desc: "Cập nhật để có tính năng mới.",
        update_btn: "Cập nhật",
        updating: "Đang cập nhật...",
        offline_title: "Bạn đang ngoại tuyến",
        offline_desc: "Vui lòng kiểm tra internet.",
        copy_success: "Đã sao chép",
        copy_fail: "Lỗi sao chép"
    },

    settings: {
        title: "应用设置",
        general: "常规设置",
        push_title: "推送通知",
        push_desc: "接收更新通知",
        app_info: "应用信息",
        current_version: "当前版本",
        danger_zone: "Danger Zone",
        delete_account_title: "注销账号 (返回现实)",
        delete_account_desc: "所有数据将被删除且无法恢复。",
        delete_account_button: "返回现实"
    },
    proposal: {
        title: "星之智慧",
        desc: "您闪耀的智慧拓展了宇宙。",
        label_title: "提案标题",
        placeholder_title: "输入您的核心想法",
        label_content: "详细内容",
        placeholder_content: "请自由分享您的想法。越具体越好!",
        btn_submit: "发送智慧",
        success_title: "智慧已接收",
        success_desc: "{name}的智慧已记录。<br>感谢您的宝贵反馈。"
    },
    report: {
        title: "举报中心",
        category_label: "CATEGORY",
        content_label: "CONTENT",
        url_label: "RELATED URL",
        categories: {
            general: "一般咨询 / 其他",
            spam: "垃圾信息 / 不当广告",
            abuse: "辱骂 / 仇恨言论",
            adult: "成人内容 / 对未成年人有害",
            bug: "系统错误 / Bug"
        },
        placeholder_content: "请详细描述问题。",
        btn_submit: "提交举报",
        warning: "虚假举报可能会导致服务限制。",
        success_title: "举报已发送",
        success_desc: "我们将尽快审核并处理。<br>感谢您的举报。",
        login_required: "您需要登录才能举报。",
        submit_success: "举报提交成功。\n请在管理中心查看...",
        error: "提交举报时发生错误",
        modal: {
            title: "举报",
            desc: "请选择举报原因。虚假举报可能会导致服务限制。",
            category: "分类",
            detail: "详细内容",
            url: "相关链接",
            submit: "提交",
            cancel: "取消"
        },
        reason: {
            spam: "垃圾信息 / 推广",
            abusive: "辱骂 / 谩骂",
            inappropriate: "不当内容",
            other: "其他 / 咨询"
        }
    },
    guide: {
        title: "系统设置",
        desc: "我们正在微调指南针<br>以协助您的旅程。",
        wait: "请稍候。"
    },
    viewer: {
        settings_title: "音频/滚动设置",
        bgm_volume: "BGM音量",
        bgm_off: "关闭BGM",
        auto_speed: "自动速度",
        settings_btn: "设置",
        translate_btn: "AI翻译",
        tts_btn: "TTS朗读",
        bgm_btn: "BGM",
        top_btn: "顶部",
        auto_play: "自动幻灯片",
        auto_scroll: "自动滚动",
        start_auto: "自动播放",
        stop_auto: "已停止",
        tts_warn: "注: TTS以原文(韩语)朗读。"
    },
    login: {
        subtitle: "想象变成现实的地方",
        btn_google: "使用Google继续",
        or: "或",
        label_email: "邮箱",
        label_password: "密码",
        btn_email_login: "邮箱登录",
        btn_email_signup: "邮箱注册",
        msg_no_account: "没有账号?",
        msg_has_account: "已有账号?",
        btn_signup: "注册",
        btn_login: "登录",
        msg_processing: "处理中...",
        msg_email_sent: "验证邮件已发送。请检查并登录。",
        err_invalid_auth: "邮箱或密码无效。",
        err_email_in_use: "该邮箱已被使用。",
        err_default: "发生错误。"
    },
    terms: {
        title: "入境审查",
        desc: "欢迎来到SSULWHA世界。<br>请同意使用条款。",
        required: "[必须]",
        optional: "[可选]",
        label_terms: "服务条款",
        label_privacy: "隐私政策",
        label_marketing: "营销同意",
        btn_start: "开始",
        btn_processing: "处理中..."
    },
    main: {
        banner_welcome: "✨ 今天就开始探索SSULWHA世界吧!",
        search_placeholder: "搜索作品、作者、标签...",
        hall_of_fame: "名人堂 (Weekly Best)",
        hall_of_fame_locked: "名人堂仅限会员查看",
        hall_of_fame_desc: "这周谁是最活跃的用户? 登录查看排名!",
        login_btn: "登录",
        todays_pick: "今日精选",
        continue_reading: "继续阅读",
        trending: "热门趋势",
        new_arrivals: "最新更新",
        all_works: "所有作品",
        tag_cloud: "按标签",
        filter_all: "全部",
        filter_webtoon: "网络漫画",
        filter_webnovel: "网络小说",
        realtime_club: "实时Ssulwha俱乐部",
        enter_club: "进入",
        be_the_first: "发射第一颗星星!",
        go_to_plaza: "前往广场",
        search_results: "搜索结果: '{query}'",
        search_no_results: "未找到结果。",
        search_try_other: "请尝试其他关键词。",
        splash_loading: "正在进入Ssulwha世界...",
    },
    mypage: {
        tab_library: "书库",
        tab_history: "历史",
        tab_activity: "活动",
        tab_likes: "收藏",
        tab_wallet: "钱包",
        tab_settings: "设置",
        no_activity: "没有活动。",
        go_to_plaza: "前往广场",
        followers: "粉丝",
        following: "关注中",
        edit_profile_tooltip: "编辑资料",
        role_author: "作家",
        role_reader: "读者",
        role_admin: "管理员",
        author_pending: "⏳ 审核中",
        btn_studio: "创作者工作室",
        btn_apply_author: "成为作家",
        default_bio: "请输入简短介绍。",
        menu_edit_profile: "编辑个人资料",
        menu_public_profile: "公开资料",
        current_version: "当前版本",
        invite_title: "邀请朋友",
        invite_reward: "奖励 +500P",
        invite_desc: "分享链接。您和朋友都将获得500P!",
        invited_count: "已邀请",
        unit_people: "人",
        edit_profile_title: "编辑个人资料",
        label_photo: "头像",
        btn_upload: "上传",
        btn_random: "随机",
        placeholder_photo_url: "或图片URL",
        label_nickname: "昵称",
        label_bio: "简介",
        placeholder_bio: "简单的自我介绍"
    },

    plaza: {
        title: "Ssulwha俱乐部",
        subtitle: "Z世代的情感交流空间",
        btn_sync: "⚡ 同步评论 (Admin Only)",
        composer_placeholder_init: "你想在这个宇宙发射什么样的故事?",
        composer_placeholder_thread: "接着写故事...",
        composer_placeholder_quote: "留下关于这个故事的想法...",
        btn_add_thread: "添加线索",
        btn_submit: "发射星星",
        btn_submit_quote: "引用",
        btn_submitting: "上传中...",
        quote_suffix: " 引用了"
    },
    recommendation: {
        loading_title: "正在读取您的轨迹...",
        loading_desc: "连接过去的足迹和您停留的星球",
        fallback_title: "<span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span>的星座<br>还很模糊。",
        fallback_desc: "但请放心。<br>我们挑选了照亮其他人夜晚的闪耀故事。<br><span class=\"text-sm opacity-70 mt-1 block\">随着足迹的增加，我们将找到专属于您的轨道。</span>",
        personal_title: "<span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span>的书架，<br>下一个插槽的故事",
        personal_desc: "我们找到了5颗与您的品味共鸣的星星。",
        label_empty_shelf: "空书架 (The Empty Shelf)",
        btn_refresh: "其他推荐",
        error_title: "连接不稳定",
        btn_retry: "重试",
        empty_data_title: "数据不足",
        btn_browse: "浏览作品",
        widget_title: "寻找下一本书?",
        widget_desc: "我们根据{name}的品味挑选了5部作品。",
        widget_desc_guest: "我们根据您的品味挑选了5部作品。",
        btn_check: "立即查看"
    },
    star_station: {
        title: "星星驿站",
        subtitle: "更自由地享受作品。",
        my_stars: "我的星星",
        history_tab: "历史",
        products_tab: "商品",
        payment_method: "支付方式",
        btn_charge: "充值",
        history_empty: "无充值记录。",
        product_names: {
            stardust: "星尘",
            shooting_star: "流星",
            little_bear: "小熊座",
            silver_river: "银河",
            galaxy_master: "星系大师",
            star_maker: "造星者"
        }
    },
    studio: {
        title: "创作者工作室",
        desc: "为您无限想象力准备的空间。",
        dashboard: "仪表盘",
        series: "系列管理",
        statistics: "统计",
        profit: "收益",
        guide: "作者指南",
        new_series: "新系列",
        edit_series: "编辑系列",
        new_episode: "新剧集",
        edit_episode: "编辑剧集",
        open_menu: "打开菜单",
        exit: "退出",
        lab_badge: "LAB",
        lab_title: "达芬奇实验室",
        lab_desc: "用AI开启新的创作世界。",
        total_views: "阅读量",
        total_likes: "点赞",
        total_followers: "粉丝",
        weekly_performance: "每周表现",
        views_trend_7d: "阅读趋势(7天)",
        live_data: "LIVE",
        my_series_list: "我的作品",
        total_series_count: "共 {n} 部",
        empty_series_title: "开始新的故事",
        empty_series_desc: "向世界展示您的想象力。",
        btn_editor: "编辑器",
        btn_settings: "设置",
        btn_delete: "删除",
        delete_modal_title: "删除系列",
        delete_modal_content: "确定要删除 '{title}' 吗? 此操作无法撤销。",
        create_first_episode: "创建您的第一个剧集!",
        create_first_episode_desc: "点击新剧集按钮开始。",
        last_updated: "最后更新: {date}",
        delete_episode_title: "删除剧集",
        delete_episode_content: "确定要删除剧集 '{title}' 吗?",

        // Toolbar
        bold: "粗体",
        italic: "斜体",
        highlight_red: "高亮 (红)",
        highlight_blue: "高亮 (蓝)",
        save_preserve_status: "保存并保持当前状态"
    },
    editor: {
        davinci_editor: "达芬奇 编辑器",
        webnovel_editor: "网络小说 编辑器",
        webtoon_editor: "网络漫画 编辑器",
        episode_title: "剧集标题",
        placeholder_title: "输入剧集标题",
        content: "内容",
        placeholder_content: "在此书写您的故事...",
        author_note: "作者留言",
        placeholder_note: "给读者的话...",
        upload_image: "上传图片",
        upload_cover: "上传封面",
        save_draft: "保存草稿",
        publish: "发布",
        ai_analysis: "AI分析",
        ai_recommend: "AI推荐",
        tags: "标签",
        placeholder_tags: "添加标签 (逗号分隔)",
        preview: "预览",
        cover_image: "Cover Image",
        cover_url: "Cover URL",
        series_status: "Series Status",
        admin_info: "Admin Info",
        format: "Format",

        publish_now: "Publish",
        settings: "设置",
        episode_prefix: "剧集",
        draft_mode_title: "草稿模式",
        draft_mode_private_desc: "该剧集当前已隐藏。",
        display_mode: "显示模式",
        mode_webtoon: "网络漫画 (滚动)",
        mode_comic: "漫画 (分页)",
        mode_insta: "Ins条漫",
        mode_desc: "优化观看体验。",
        thumbnail: "缩略图",
        bgm: "BGM",
        manuscript_images: "原稿",
        drag_drop_hint: "拖放图片 或 点击上传",
        set_draft: "转为草稿",
        save_changes: "保存更改",
        live_preview: "实时预览",
        preview_hint: "检查在移动设备上的显示效果。",
        val_webtoon_error: "[网络漫画模式错误] 图片太宽 (比例: {ratio})。<br>网络漫画模式需要垂直滚动 (高度 > 宽度 * 1.2)。<br>单页请使用'漫画'模式。",
        val_comic_error: "[漫画模式错误] 无效的宽高比 ({ratio})。<br>允许的格式:<br>- 垂直页 (约 2:3 到 3:4)<br>- 水平跨页 (宽度 > 高度)<br><br>长条图请使用'网络漫画'模式。",
        val_insta_error: "[Ins条漫错误] 无效的宽高比 ({ratio})。<br>Instagram优化需要正方形 (1:1) 或 纵向 (4:5)。<br>当前图片太宽或太高。",
        approval_requested: "已申请审核",
        approval_desc: "这是该系列的首次发布。<br>管理员将很快审核。",
        pending_approval: "等待审核",
        saved_to_draft: "已保存到草稿",
        published_start_ai: "剧集已发布! 正在启动AI分析...",
        ai_trigger_fail: "启动AI分析失败。请手动使用'AI分析'按钮。",
        save_failed: "保存失败: {e}",
        upload_complete: "上传完成",
        upload_fail_desc: "图片上传失败。(URL生成失败)\n请检查控制台日志。",
        image_mode_mismatch: "选择的图片不符合 {mode} 模式规格。",
        invalid_format: "格式无效",
        mode_change_blocked: "模式更改被阻止",
        mode_change_blocked_desc: "现有图片中有不符合 {mode} 规格的文件。请删除它们并重试。",
        processing: "处理中...",
        tap_nav_hint: "点击边缘导航 或 滚动",
        ai_analyze_title: "确认AI分析",
        ai_analyze_confirm: "要对这些图片运行AI分析(OCR)吗?\\n现有的分析数据将被更新。",
        save_required: "请先保存剧集。",
        ai_requesting: "正在请求AI服务器... (OCR/SEO)",
        ai_processing_title: "AI处理中",
        ai_no_items: "未分析任何项目 (0)。\\n\\n[详细]\\n{log}",
        diagnosis_report: "诊断报告",
        ocr_complete: "OCR完成: {n}帧",
        seo_trigger: "自动SEO生成已触发。",
        ai_complete_desc: "分析完成。\\n- OCR数据已创建\\n- SEO元数据等待中\\n(稍后显示)",
        ai_error: "AI处理错误",
        ai_fail_msg: "AI分析失败: {e}",
        title: "Novel Studio",
        master_detail: "Master-Detail View",
        save: "保存",
        saved: "已保存",
        saving: "保存中...",
        complete: "完成",



        error: "错误",
        ai_analyze_btn: "AI分析",
        ai_analyzing: "分析中...",
        series_info: "系列信息 (Upload)",
        series_title: "系列标题",

        admin_readonly: "仅限管理员 (Read Only)",
        chapters: "章节列表",
        add_chapter: "添加章节",
        delete_chapter_confirm: "删除此章节?",
        untitled_episode: "无标题",
        bgm_label: "BGM (可选)",
        content_body: "内容",
        load_txt: "加载TXT",
        text_too_short: "文本太短。",
        upload_cover_fail: "封面上传失败",
        create_series: "创建系列",
        edit_series: "编辑系列",
        basic_info: "基本信息",
        episode_mgmt: "剧集管理",
        compliance: "合规性 (Compliance)",
        age_rating: "年龄分级",
        age_guide: "指南",
        is_ai: "使用AI内容",
        desc_placeholder: "输入剧情简介...",


        format_locked: "锁定",
        webtoon: "网络漫画 (Webtoon)",
        webnovel: "网络小说 (Webnovel)",
        cinenovel: "剧画 (Cine-Novel)",
        admin_id: "ID Code (Admin Only)",
        ai_context_analysis_confirm: "Run AI Context Analysis?\n(Existing data will be overwritten)",
        ai_analyzing_background: "Requesting AI Analysis... (Background)",
        ai_no_items_found: "No items analyzed...",
        upload_fail: "Upload Failed: ",
        creating_episode: "Creating New Episode...",
        episode_not_found: "Episode not found.",
        uploading_images_toast: "Uploading images...",
        approval_request_sent: "Approval request sent. (Pending Admin Review)",
        publish_success: "Successfully Published!",
        temp_saved_toast: "Temporarily Saved.",
        deleted_toast: "Deleted.",
        access_denied: "Access Denied",


        series_info_upload: "Series Info (Upload)",
        cover_upload_fail: "Cover Upload Failed: ",
        save_success: "Saved",



        input_title_placeholder: "Enter title",


        free_limit_placeholder: "Leave empty for global/series default",
        free_limit_desc: "* Overrides global settings if set.",
        admin_edit_anytime: "* Admin can edit this anytime.",



        preview_preparing: "Preparing preview...",

        select_chapter: "Select a chapter",
        episode_placeholder: "ex) Ep. 1",
        bgm_placeholder: "Suno AI URL...",

        ai_analysis_fail: "AI Analysis Failed: ",
        save_fail: "Save Failed: ",

        bold: "Bold",
        italic: "Italic",
        highlight_red: "Highlight (Red)",
        highlight_blue: "Highlight (Blue)",
        save_preserve_status: "Save (Preserve Status)",
        new_episode: "New Episode",


        publish_confirm: "Are you sure you want to publish?",

        novel_editor: "Webnovel Editor",
        auto_saved: "Auto Saved",
        untitled_chapter: "Untitled",
        chapter_title_placeholder: "Chapter Title",
        publish_settings: "Publish Settings",
        delete_title: "Delete Chapter",
        save_button: "Save",
        novel_info: "Novel Info",
        novel_title: "Novel Title",
        tags_placeholder: "Romance, Fantasy",
        chapter_list: "Chapter List",
        chapter_count: "Total {n} Episodes",
        add_empty_chapter: "Add Empty Chapter",

        public_toggle: "Public",
        private_toggle: "Private",
        bgm_suno_label: "BGM Settings",
        txt_upload: "Upload TXT",
        content_placeholder: "Enter content...",
        note_placeholder: "Author's note...",
        ai_analysis_complete: "AI Analysis Complete",
        recommend_keywords: "Keywords",
        hook: "Hook",
        analysis_saved: "Data saved.",
        analysis_fail: "Analysis failed.",
        analysis_short: "Content too short.",
        age_all: "All",
        age_12: "12+",
        age_15: "15+",
        age_19: "19+",
        rating_label: "Rating",
        age_19_desc: "Blocks minors.",
        age_lock_warning: "Warning: Cannot change after save.",
        free_limit: "免费限制 (Local Override)",
        cancel: "取消",
        create: "创建",
        episode_list: "剧集列表",
        open_editor_fullscreen: "打开编辑器 (Full)",
        editor_guide_text: "* 使用'打开编辑器'进行更改。",
        admin_zone: "管理员区",
        admin_zone_desc: "此信息受限。",
        download_csv: "下载CSV (ISBN)",
        adult_confirm_title: "18+ 警告",
        adult_confirm_body: "设置为'成人(19+)'?\\n\\n- 将阻止未成年人访问。\\n- 可能需要身份验证。",
        davinci_lock_title: "🚧 开发中",
        davinci_lock_desc: "达芬奇模式(Cine-Novel)处于Beta测试中。<br>由于不稳定，仅限<strong>管理员</strong>访问。<br><div class='mt-3 text-rose-400 font-bold'>敬请期待。</div>",

        ai_analyze_local: "AI Context Analysis",
        ai_confirm: "AI Confirmation",
    },

    rating_guide: {
        title: "内容评级指南",
        all_title: "全年龄",
        all_desc: "适合所有年龄段的内容。<br>没有或极少有暴力、色情内容或不当语言。",
        title_12: "12+ (青少年)",
        desc_12: "可能包含轻微暴力、不雅语言或恐怖内容。<br>建议12岁以下儿童在家长指导下观看。",
        title_15: "15+ (青年)",
        desc_15: "可能包含中度暴力、强烈语言或成熟主题。<br>可能描写犯罪行为或社会禁忌。",
        title_19: "19+ (仅限成人)",
        desc_19: "包含露骨的性内容、极端暴力或辱骂语言。<br><strong class='text-red-500'>法律限制19岁以上成人观看。需要身份验证。</strong>",
        disclaimer: "* 评级是作者的责任。虚假评级可能导致强制更改或处罚。",
        confirm: "明白了"
    },
    davinci: {
        episode_settings: "剧集设置",
        title: "标题",
        thumbnail: "缩略图",
        bgm: "BGM",
        add_block: "添加块",
        text_block: "文本",
        image_block: "图片",
        upload_image: "上传图片",
        upload_thumb: "上传缩略图",
        upload_success: "已上传",
        bgm_placeholder: "Suno URL 或 MP3链接",
        tip: "提示:",
        drag_tip: "拖动块进行排序。",
        save_draft: "保存草稿",
        publish: "发布",
        saving: "保存中...",
        published: "已发布! 读者可见。",
        publish_confirm: "立即发布? 读者将看到此内容。",
        preview_preparing: "准备预览...",
        thumbnail_uploading: "缩略图上传中...",
        thumbnail_applied: "缩略图已应用",
        guide: {
            title: "按钮指南",
            save: "保存",
            save_desc: "保存更改。",
            draft: "草稿",
            draft_desc: "切换为私有。",
            publish: "发布",
            publish_desc: "公开。(读者可见)",
            auto_save: "自动保存",
            auto_save_on: "开启 (3秒)",
            auto_save_desc: "每3秒自动保存。"
        }
    },
    intro: {
        slogan: "人类的创造力，AI的扩展性",
        hero_title: "用于电影小说的",
        hero_subtitle: "巴别鱼 (Babel Fish)",
        status_active: "实时翻译引擎已激活",
        status_cine: "电影小说格式",
        desc_1: "利用我们的非破坏性AI引擎，以<span class='text-white font-bold mx-1'>10种语言</span>即时阅读韩国IP。",
        desc_2: "体验视觉与小说完美融合的<span class='text-white font-bold mx-1'>世界首创混合格式</span>。",
        cta_start: "免费开始阅读",
        compare_title: "破坏性 vs 非破坏性",
        compare_desc: "我们从未触碰原始像素。请看区别。",
        compare_old: "旧方法 (白框)",
        compare_new: "Ssulwha 引擎 (R.A.P.S)",
        white_box_removed: "已移除的白框",
        format_title: "超越静态图像",
        format_desc: "网漫的视觉。小说的深度。电影般的沉浸感。",
        geo_title: "AI驱动的增长",
        geo_desc: "我们不做营销。我们的AI代劳。",
        term_log_1: "正在分析内容...",
        term_log_2: "提取关键词...",
        term_log_3: "注入 JSON-LD 元数据...",
        term_log_4: "自然流量增长 +300%",

        // Missing Keys Added
        slider_old_title: "旧方法",
        slider_old_desc: "遮挡了艺术",
        slider_new_title: "Ssulwha 引擎 (R.A.P.S)",
        slider_new_desc_1: "“这才是本来的样子。”",
        slider_new_desc_2: "文字自然浮动，保留了画作。",

        phone_analyzing: "正在分析...",
        phone_detected: "检测到",
        phone_text_1: "这是我的命运吗？",
        phone_cine_ep: "电影小说 EP.01",
        phone_cine_text_1: "霓虹灯闪烁，映照在他冰冷的眼中。",
        phone_cine_text_2: "“这不仅仅是翻译，”他低声说。“这是新的现实。”",

        footer_copyright: "由 R.A.P.S 引擎驱动。"
    }
};
